import React, { useEffect, useCallback } from 'react';
import ScrollReveal from 'scrollreveal';

// Import components
import About from './components/about';
import Header from './components/header';
import Home from './components/home';
import Portfolio from './components/portfolio';
import Services from './components/services';
import Testimonial from './components/testimonial';
import Contact from './components/contact';
import Footer from './components/footer';

// Import styles
import './assets/css/style.css';

function App() {
    const initializeMenuToggle = useCallback(() => {
        const menuIcon = document.querySelector('#menu-icon');
        const navbar = document.querySelector('.navbar');

        if (menuIcon && navbar) {
            menuIcon.onclick = () => {
                menuIcon.classList.toggle('bx-x');
                navbar.classList.toggle('active');
            };
        }
    }, []);

    const initializeScrollSpy = useCallback(() => {
        const sections = document.querySelectorAll('section');
        const navLinks = document.querySelectorAll('header nav a');
        const header = document.querySelector('.header');
        const menuIcon = document.querySelector('#menu-icon');
        const navbar = document.querySelector('.navbar');

        const handleScroll = () => {
            const scrollY = window.scrollY;

            sections.forEach(sec => {
                const offset = sec.offsetTop - 150;
                const height = sec.offsetHeight;
                const id = sec.getAttribute('id');

                if (scrollY >= offset && scrollY < offset + height) {
                    navLinks.forEach(link => {
                        link.classList.remove('active');
                        const activeLink = document.querySelector(`header nav a[href*="${id}"]`);
                        if (activeLink) activeLink.classList.add('active');
                    });
                }
            });

            if (header) {
                header.classList.toggle('sticky', scrollY > 100);
            }

            if (menuIcon && navbar) {
                menuIcon.classList.remove('bx-x');
                navbar.classList.remove('active');
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const initializeDarkMode = useCallback(() => {
        const darkModeIcon = document.querySelector('#darkMode-icon');

        if (darkModeIcon) {
            const savedMode = localStorage.getItem('darkMode');
            if (savedMode === 'enabled') {
                document.body.classList.add('dark-mode');
                darkModeIcon.classList.add('bxs-sun');
            }

            darkModeIcon.onclick = () => {
                darkModeIcon.classList.toggle('bxs-sun');
                document.body.classList.toggle('dark-mode');
                
                if (document.body.classList.contains('dark-mode')) {
                    localStorage.setItem('darkMode', 'enabled');
                } else {
                    localStorage.setItem('darkMode', 'disabled');
                }
            };

            darkModeIcon.onkeydown = (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    darkModeIcon.click();
                }
            };
        }
    }, []);

    const initializeScrollReveal = useCallback(() => {
        const sr = ScrollReveal({
            reset: true,
            distance: '80px',
            duration: 2000,
            delay: 200
        });

        sr.reveal('.home-content, .heading', { origin: 'top' });
        sr.reveal('.home-img img, .services-container, .portfolio-box, .testimonial-wrapper, .contact form', { origin: 'bottom' });
        sr.reveal('.home-content h1, .about-img img', { origin: 'left' });
        sr.reveal('.home-content h3, .home-content p, .about-content', { origin: 'right' });

        return () => sr.destroy();
    }, []);

    useEffect(() => {
        initializeMenuToggle();
        const cleanupScrollSpy = initializeScrollSpy();
        initializeDarkMode();
        const cleanupScrollReveal = initializeScrollReveal();

        return () => {
            cleanupScrollSpy();
            if (typeof cleanupScrollReveal === 'function') {
                cleanupScrollReveal();
            }
        };
    }, [initializeMenuToggle, initializeScrollSpy, initializeDarkMode, initializeScrollReveal]);

    return (
        <div className="App">
            <Header />
            <Home />
            <About />
            <Services />
            <Portfolio />
            <Testimonial />
            <Contact />
            <Footer />
        </div>
    );
}

export default App;